<div data-testid="serial-profile-dialog-container" class="serial-profile-dialog p-1">
  <!-- Form Fields -->
  <div class="space-y-4">
    <!-- Name - Required -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.serial_profile.common.name" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        data-testid="serial-profile-dialog-name-input"
        type="text"
        pInputText
        [placeholder]="'settings.serial_profile.common.enter_name' | translate"
        [(ngModel)]="formData.name"
        class="w-full"
        [class.border-red-300]="showErrors() && !formData.name"
      />
      @if (showErrors() && !formData.name) {
        <p class="text-red-500 text-xs mt-1">
          {{ "settings.serial_profile.form.errors.name_required" | translate }}
        </p>
      }
    </div>

    <!-- Description -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.serial_profile.common.description" | translate }}
      </label>
      <textarea
        data-testid="serial-profile-dialog-description-textarea"
        pTextarea
        [placeholder]="
          'settings.serial_profile.common.enter_description' | translate
        "
        [(ngModel)]="formData.description"
        [rows]="3"
        class="w-full"
      ></textarea>
    </div>

    <!-- Status - Only show in edit mode -->
    @if (isEditMode) {
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          {{ "settings.serial_profile.common.status" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-select
          data-testid="serial-profile-dialog-status-select"
          [options]="statusOptions"
          optionLabel="label"
          optionValue="value"
          [optionDisabled]="'disabled'"
          [placeholder]="
            'settings.serial_profile.form.placeholders.select_status'
              | translate
          "
          [(ngModel)]="formData.status"
          styleClass="w-full"
        />
      </div>
    }

    <!-- Tracking Rules -->
    <div class="space-y-3">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.serial_profile.form.fields.tracking_rules" | translate }}
      </label>

      <div class="flex items-center gap-2">
        <p-checkbox
          data-testid="serial-profile-dialog-lot-required-checkbox"
          [(ngModel)]="formData.lotRequired"
          [binary]="true"
          inputId="lotRequired"
        ></p-checkbox>
        <label for="lotRequired" class="text-sm text-gray-700 cursor-pointer">
          {{ "settings.serial_profile.form.fields.require_lot" | translate }}
        </label>
      </div>

      <div class="flex items-center gap-2">
        <p-checkbox
          data-testid="serial-profile-dialog-expiry-required-checkbox"
          [(ngModel)]="formData.expiryRequired"
          [binary]="true"
          inputId="expiryRequired"
        ></p-checkbox>
        <label
          for="expiryRequired"
          class="text-sm text-gray-700 cursor-pointer"
        >
          {{ "settings.serial_profile.form.fields.require_expiry" | translate }}
        </label>
      </div>

      <div class="flex items-center gap-2">
        <p-checkbox
          data-testid="serial-profile-dialog-serial-required-checkbox"
          [(ngModel)]="formData.serialRequired"
          [binary]="true"
          inputId="serialRequired"
        ></p-checkbox>
        <label
          for="serialRequired"
          class="text-sm text-gray-700 cursor-pointer"
        >
          {{ "settings.serial_profile.form.fields.require_serial" | translate }}
        </label>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-200">
    <app-button
      [testId]="'serial-profile-dialog-cancel-btn'"
      [label]="'common.actions.cancel' | translate"
      type="secondary"
      [outlined]="true"
      (emitOnClick)="onCancel()"
    ></app-button>
    <app-button
      [testId]="'serial-profile-dialog-save-btn'"
      [label]="'common.actions.save' | translate"
      type="info"
      (emitOnClick)="onConfirm()"
    ></app-button>
  </div>
</div>
